/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "./utilities/updateClasses";
import {itemcardSubscriptions} from "./subscriptions";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "./iconbarHover";
import {initCustomSelects} from "./customSelect";
import {initToggleSlide} from "./toggle";
import {XhrService} from "../ts/xhr.service";
import {appendScriptToDOM} from "./utilities/functions";
import {initFormSubmitChanges} from "./actionClick";
import {closeModal, showModal} from "./modal";
import {initInputBody} from "./inputfile";
import {focusInputGroups} from "./checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "./itemlistStickyOrderBar";
import {getAllQuantityInputs} from "./quantitySpinner";
import {initContentTabs} from "./contentTabs";
import {enableEditableInputs} from "../../../reusch_global/js/global/editableInput";
import {initDatepickerWithAjax} from "./datepicker";

function updateBasketCount(doc) {
    for (let basketCount of document.querySelectorAll('.js-basketCount')) {
        let firstNewBasketCount = doc.querySelector('.js-basketCount');
        if (firstNewBasketCount) {
            let count = parseInt(firstNewBasketCount.innerText);
            if (isNaN(count)) {
                count = 0;
            }
            if (count === 0) {
                basketCount.style.display = "none";
            } else {
                addActionClass(basketCount, function () {
                    basketCount.style.display = "";
                });
            }
        }
    }
}


function updateItem(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-addListItemToBasket[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateItemModal(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-openMultiBasketModal[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateOrderButtonItemcard(doc) {
    let itemcardBuybox = document.querySelector(".itemcardBuybox");
    let newItemcardBuybox = doc.querySelector('.itemcardBuybox');

    if (itemcardBuybox) {
        itemcardBuybox.innerHTML = newItemcardBuybox.innerHTML;

        itemcardSubscriptions(itemcardBuybox);
        initCustomSelects(itemcardBuybox.querySelectorAll(".js-customSelect"));
    }
}

function updateHeaderBasket(doc, showBasketHover = true) {
    let delayBasketHover = 6000;
    // Aktuell ausgewählten Wert merken
    const selectedBasketId = document.getElementById('selectBasket')?.value;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (let headerBasket of document.querySelectorAll('.js-headerBasket')) {
        let newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            if (showBasketHover) {
                headerBasket.classList.add("showIconbarHover");
                showIconbarHover(headerBasket);
            }
            initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));
            let basketCount = headerBasket.querySelector('.js-basketCount');

            if (basketCount) {
                addActionClass(basketCount);
            }

            setTimeout(function () {
                hideIconbarHover(headerBasket);
            }, delayBasketHover);
        }
    }
}


function isCurrentBasketUpdated(updatedBasketIds) {
    const activeBasketOption = document.querySelector('#selectBasket option.js-selectCurrentBasket[selected]');
    if (!activeBasketOption) return false;

    const currentBasketId = activeBasketOption.getAttribute('data-basket-id');

    if (Array.isArray(updatedBasketIds)) {
        return updatedBasketIds.includes(currentBasketId);
    }

    return updatedBasketIds == currentBasketId;
}


export function setCurrentBasketAndReloadWithXhr(basketId) {
    let formData = new FormData();
    formData.set('basket_id', basketId);
    formData.set('action_id', 'setCurrUserBasket');

    // Aktuell ausgewählten Wert merken
    const selectedBasketId = document.getElementById('selectBasket')?.value;

    XhrService.generalAjaxCall('setCurrUserBasket', formData, 'POST', 'json').then(data => {
               if (data.headerBasketContent) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.headerBasketContent, 'text/html');
            // Verwende die bestehende Funktion, um den Header zu aktualisieren
            updateHeaderBasket(doc, false);
            changeCurrentBasket();

        } else {
            console.error('Unerwartete Antwortstruktur:', data);
        }
    }).catch(error => {
        console.error('Fehler beim Laden des Warenkorbs:', error);
    });
}



function dispatchCustomUpdateBasketViewsEvent(data,name="updateBasketViews"){
    document.dispatchEvent(new CustomEvent(name, {
        detail: { data }
    }));
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    // Schutz, falls currentTab/basketView mal null ist
    if (!basketView) return;

    // Normale Quantity-Inputs (nicht die editable Rabatt/Preis-Felder)
    const quantityInputs = basketView.querySelectorAll(
        ".js-itemBasketList .quantity input[type='number']"
    );
    if (!quantityInputs.length) return;

    quantityInputs.forEach(quantity => {
        const form = quantity.closest(".js-itemBasketList");
        if (!form) return;

        const triggerSave = () => {
            clearTimeout(updateTimeout);
            lockCheckoutButtons();
            updateTimeout = setTimeout(() => {
                sendBasketForm(form, basketView);
            }, 1000); // wie in deiner alten Funktion
        };

        // Änderung an Menge -> speichern (debounced)
        quantity.addEventListener("change", triggerSave);

        // Enter -> sofort speichern (ohne zusätzliches Delay)
        quantity.addEventListener("keyup", (e) => {
            if (e.key === "Enter") {
                clearTimeout(updateTimeout);
                sendBasketForm(form, basketView);
            }
        });
    });
}

function eventListenerBasketViewQuantitiesOLD2(basketView, updateTimeout) {
    for (let quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        let form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 500);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    // Hilfsfunktion: Standard-Eventlistener für Input & Save
    const addInputListeners = (input, saveIcon, form, triggerSaveExtra, toggleDisplay) => {
        if (!input || !saveIcon || !form) return;

        let originalValue = input.value; // Startwert merken
        let changed = false;

        const triggerSave = () => {
            clearTimeout(updateTimeout);
            lockCheckoutButtons();

            if (typeof toggleDisplay === "function") {
                toggleDisplay();
            }

            updateTimeout = setTimeout(() => {
                // Wenn geändert → temporäres Hidden-Input hinzufügen
                let tempInput;
                if (changed) {
                    const lineId = form.getAttribute("data-id") || input.name || Date.now();
                    tempInput = document.createElement("input");
                    tempInput.type = "hidden";
                    tempInput.name = "input_line_changed_" + lineId;
                    tempInput.value = "true";
                    form.appendChild(tempInput);
                }

                sendBasketForm(form, basketView);

                // Nach Ajax-Call wieder entfernen
                if (tempInput) {
                    tempInput.remove();
                }

                if (typeof triggerSaveExtra === "function") triggerSaveExtra();
                
                // Reset changed state after save
                changed = false;
                originalValue = input.value;
            }, 1000);
        };

        input.addEventListener("input", () => {
            changed = input.value !== originalValue;
        });

        input.addEventListener("focus", () => { input.value = ""; });
        saveIcon.addEventListener("click", triggerSave);
        input.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                triggerSave();
            }
        });
    };


    if (!basketView) return;

    // 1. Fall: Normale BasketList-Inputs
    basketView.querySelectorAll('.js-itemBasketList .js-editableInput').forEach(wrapper => {
        const input = wrapper.querySelector('input[type="number"]');
        const saveIcon = wrapper.querySelector('.icon-save');
        const form = wrapper.closest(".js-itemBasketList");
        addInputListeners(input, saveIcon, form);
    });

    // 2. Fall: SalesPersonDiscount allgemein
    basketView.querySelectorAll('.salesPersonDiscount .itemBasketBox__discount .spDiscount').forEach(wrapper => {
        const input = wrapper.querySelector('input[type="number"]');
        const saveIcon = wrapper.querySelector('.icon-save');
        const form = wrapper.closest("form");
        addInputListeners(input, saveIcon, form);
    });

    // 3. Fall: Nur Größenrabatte (colorVariants + sizeVariants)
    basketView.querySelectorAll('.itemBasketBox.colorVariant').forEach(colorBox => {
        const dataId = colorBox.getAttribute('data-id');
        const discountWrapper = colorBox.querySelector('.itemBasketBox__discount .spDiscount');
        if (!discountWrapper) return;

        const input = discountWrapper.querySelector('input[type="number"]');
        const saveIcon = discountWrapper.querySelector('.icon-save');
        const form = colorBox.closest('form');

        // Hauptlistener für Farbvariante
        addInputListeners(input, saveIcon, form);

        // Zusätzlich: alle zugehörigen sizeVariants beobachten
        let next = colorBox.nextElementSibling;
        while (next) {
            if (
                next.classList.contains('itemBasketBox.colorVariant') ||
                next.classList.contains('itemBasketBox.salesPersonDiscount')
            ) {
                break;
            }

            if (
                next.classList.contains('itemBasketBox') &&
                next.classList.contains('sizeVariant') &&
                next.getAttribute('data-id') === dataId
            ) {
                const sizeDiscountWrapper = next.querySelector('.itemBasketBox__discount .spDiscount');
                const sizeInput = sizeDiscountWrapper?.querySelector('input[type="number"]');
                const sizeSaveIcon = sizeDiscountWrapper?.querySelector('.icon-save');
                addInputListeners(sizeInput, sizeSaveIcon, form);
            }

            next = next.nextElementSibling;
        }
    });

    // 4. Fall: Preisänderungen (.js-updateSizesColorsPrice)
    basketView.querySelectorAll('.salesPersonDiscount .js-updateSizesColorsPrice').forEach(wrapper => {
        const input = wrapper.querySelector('input[type="number"], input.manual_price_discount');
        const saveIcon = wrapper.querySelector('.icon-save');
        const form = wrapper.closest("form");

        // optional: ToggleDisplay aus enableEditableInputs() aufrufen, wenn du magst
        addInputListeners(input, saveIcon, form, () => {
            console.log("Preisänderung gespeichert:", input.value);
        });
    });

// Fall 5: Preisänderungen für Farb-Varianten (.js-updateSizesPrice)
    basketView.querySelectorAll('.itemBasketBox.colorVariant').forEach(colorBox => {
        const dataId = colorBox.getAttribute('data-id');
        const priceWrapper = colorBox.querySelector('.js-updateSizesPrice');
        if (!priceWrapper) return;

        const input = priceWrapper.querySelector('input[type="number"]');
        const saveIcon = priceWrapper.querySelector('.icon-save');
        const form = colorBox.closest('form');

        // Hauptlistener für Farbvariante
        addInputListeners(input, saveIcon, form);

        // Zusätzlich: alle zugehörigen sizeVariants beobachten
        let next = colorBox.nextElementSibling;
        while (next) {
            if (
                next.classList.contains('itemBasketBox.colorVariant') ||
                next.classList.contains('itemBasketBox.salesPersonDiscount')
            ) {
                break;
            }

            if (
                next.classList.contains('itemBasketBox') &&
                next.classList.contains('sizeVariant') &&
                next.getAttribute('data-id') === dataId
            ) {
                const sizePriceWrapper = next.querySelector('.js-manualPriceInput');
                const sizeInput = sizePriceWrapper?.querySelector('input[type="number"]');
                const sizeSaveIcon = sizePriceWrapper?.querySelector('.icon-save');
                addInputListeners(sizeInput, sizeSaveIcon, form);
            }

            next = next.nextElementSibling;
        }
    });



}


function eventListenerDiscountGroupSelect(basketView, updateTimeout) {
    const selectElements = basketView.querySelectorAll('select#input_discount_group');

    if (!selectElements || selectElements.length === 0) return; // Kein Select vorhanden → abbrechen

    selectElements.forEach(selectElement => {
        const form = selectElement.closest('form') || basketView;
        if (!form) return;

        selectElement.addEventListener("change", () => {
            clearTimeout(updateTimeout);
            addLoadingClass(form);
            lockCheckoutButtons();

            updateTimeout = setTimeout(() => {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    });
}

function eventListenerPriceGroupSelect(basketView, updateTimeout) {
    const selectElements = basketView.querySelectorAll('select#input_price_group');

    if (!selectElements || selectElements.length === 0) return; // Kein Select vorhanden → abbrechen

    selectElements.forEach(selectElement => {
        const form = selectElement.closest('form') || basketView;
        if (!form) return;

        selectElement.addEventListener("change", () => {
            clearTimeout(updateTimeout);
            addLoadingClass(form);
            lockCheckoutButtons();
            updateTimeout = setTimeout(() => {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    });
}





function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    if (!basketView) return; // Verhindert den Null-Fehler

    const spinners = basketView.querySelectorAll(
        '.js-itemBasketList .quantity .js-spinnerUp, .js-itemBasketList .quantity .js-spinnerDown'
    );

    spinners.forEach(spinner => {
        const form = spinner.closest(".js-itemBasketList");
        if (!form) return;

        spinner.addEventListener("click", () => {
            clearTimeout(updateTimeout);
            lockCheckoutButtons();
            updateTimeout = setTimeout(() => {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    });
}

function updateAllBasketViews(basketView, newBasketView, basketId) {
    if (!basketView || !newBasketView) return;

    // Alte Elemente
    let oldList = basketView.querySelector(`.contentTabs__basketWrapper[data-basket-id="${basketId}"] .js-itemBasketList`);
    let oldOrderBox = basketView.querySelector(`.js-basketOrderBox[data-basket-id="${basketId}"]`)
        || document.querySelector(`.js-basketOrderBox[data-basket-id="${basketId}"]`);
    let oldSummary = basketView.querySelector('.js-basketSummary');
    let oldBasketPaymentButtons = basketView.querySelector('.js-basketPaymentButtons');

    // Neue Elemente
    let newList = newBasketView.querySelector(`.contentTabs__basketWrapper[data-basket-id="${basketId}"] .js-itemBasketList`);
    let newOrderBox = newBasketView.querySelector(`.js-basketOrderBox[data-basket-id="${basketId}"]`);
    let newSummary = newBasketView.querySelector('.js-basketSummary');
    let newBasketPaymentButtons = newBasketView.querySelector('.js-basketPaymentButtons');

    // Basket List updaten
    if (newList && oldList) {
        oldList.innerHTML = newList.innerHTML;
        for (let item of basketView.querySelectorAll('.js-itemBasketList')) {
            removeLoadingClass(item);
        }
        let currentTab = basketView.querySelector('.contentTabs__basketWrapper.is-active') || basketView;
        eventListenerBasketViewQuantities(currentTab);
        eventListenerBasketViewQuantitySpinners(currentTab);
        eventListenerBasketViewSpDiscounts(currentTab);
        eventListenerDiscountGroupSelect(currentTab);
        eventListenerPriceGroupSelect(currentTab);
        initDatepickerWithAjax();
    }

    // OrderBox updaten
    if (newOrderBox && oldOrderBox) {
        oldOrderBox.innerHTML = newOrderBox.innerHTML;
        for (let item of basketView.querySelectorAll('.js-basketOrderBox')) {
            removeLoadingClass(item);
        }
        initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
        initFormSubmitChanges();
    }

    // Summary updaten
    if (newSummary && oldSummary) {
        oldSummary.innerHTML = newSummary.innerHTML;
    }

    // Basket Payment Buttons updaten
    if (newBasketPaymentButtons && oldBasketPaymentButtons) {
        oldBasketPaymentButtons.innerHTML = newBasketPaymentButtons.innerHTML;
        executeScripts(oldBasketPaymentButtons);
    }
}


function executeScripts(element) {
    let scripts = element.querySelectorAll('script');

    scripts.forEach(script => {
        let newScript = document.createElement('script');
        newScript.src = script.src;
        document.head.appendChild(newScript);
        newScript.remove();
    });
}

let basketUpdatePending = false;

function lockCheckoutButtons() {
    basketUpdatePending = true;
    for (let btn of document.querySelectorAll('.js-loadingAfterSubmit')) {
        addLoadingClass(btn);
    }
}

function unlockCheckoutButtons() {
    basketUpdatePending = false;
    for (let btn of document.querySelectorAll('.js-loadingAfterSubmit')) {
        removeLoadingClass(btn);
    }
}

export function sendBasketForm(form, basketView) {
    let formData = new FormData(form);
    for (let item of basketView.querySelectorAll('.js-itemBasketList, .js-basketOrderBox')) {
       // addLoadingClass(item);
    }
    for (let item of basketView.querySelectorAll('.js-editableInput')) {
        addLoadingClass(item);
    }
    lockCheckoutButtons();
    let basketId = 0;
    const contentBasketTab = form.closest(".contentTabs__basketWrapper");
    if (contentBasketTab) {
        basketId = contentBasketTab.dataset.basketId;
    }
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'), basketId);
            updateHeaderBasket(doc, false);
            enableEditableInputs();
            initActiveBasketDiscountField();
            dispatchCustomUpdateBasketViewsEvent({
                data
            });
            syncNoDiscountState();
            setCurrentBasketAndReloadWithXhr(basketId);
            unlockCheckoutButtons();

            console.log('Success:', data);

        })
        .catch((e) => {
            unlockCheckoutButtons();
            console.error('Error:', e);
        });
}

export function triggerBasketBtns() {
    // Vorab-Check für js-openMultiBasketModal in der Capture-Phase,
    // um konkurrierende Listener (z.B. aus modal.js) zu stoppen, wenn die Menge 0 ist.
    document.addEventListener("click", function (e) {
        let target = e.target.closest(".js-openMultiBasketModal");
        if (target) {
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper ? orderButtonWrapper.querySelector('.js-quantity-value') : null;

            if (quantityInput) {
                const quantity = parseInt(quantityInput.value, 10);
                if (isNaN(quantity) || quantity <= 0) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            }
        }
    }, true);

    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');

            if (form && quantityInput) {
                const quantity = parseInt(quantityInput.value, 10);
                if (quantity > 0) {
                    addLoadingClass(target);
                    const itemId = target.dataset.itemNo;
                    const variantCode = orderButtonWrapper.querySelector('.input_variant_code')?.value;
                    const basketId = document.querySelector('.js-currentBasket')?.dataset.basketId || document.querySelector('#selectBasket')?.value;
                    if (!basketId) {
                        console.error('Keine Basket-ID gefunden. Aktion abgebrochen, um unerwünschte Warenkorberstellung zu vermeiden.');
                        return;
                    }

                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    formData.set('item_id', itemId);
                    formData.set('variant_code', variantCode);
                    formData.set('quantity', quantity);
                    formData.set('basket_id', basketId);


                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket && response.headerBasketContent) {
                            var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                            updateHeaderBasket(doc, false);
                            setCurrentBasketAndReloadWithXhr(basketId);
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        addSuccessClass(target);
                        updateItemlistStickyOrderBarCount();
                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                            console.error('Action:', form.action);
                            console.error(formData);
                        });
                }

            }
            e.preventDefault();
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            let customizableInputValue = form.dataset.customized;
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue === '1'))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1') {
                    addLoadingClass(target);
                    let fn = 'cart';
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    if (customizableInputValue === '1') {
                        fn = 'cartCustomize';
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        addSuccessClass(target);
                        if (fn == 'cartCustomize') {
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            const basketId = document.querySelector('.js-currentBasket')?.dataset.basketId || document.querySelector('#selectBasket')?.value;
                            if (!basketId) {
                                console.error('Keine Basket-ID gefunden. Aktion abgebrochen, um unerwünschte Warenkorberstellung zu vermeiden.');
                                return;
                            }
                            if (headerBasket && response.headerBasketContent) {
                                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);
                                setCurrentBasketAndReloadWithXhr(basketId);
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                        });
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasketHover")) {
            target = target.closest(".js-removeFromBasketHover");

            addLoadingClass(target);
            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);


            XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                addSuccessClass(target);
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                const headerBasket = document.querySelector('.js-headerBasket');
                if (headerBasket && response.headerBasketContent) {
                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                    updateHeaderBasket(doc);
                }
                if (response.tagManager) {
                    appendScriptToDOM(response.tagManager, true);
                }
                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });
            e.preventDefault();
        }

        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            addLoadingClass(target);

            let form = target.closest("form");
            let formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                let customizationData = response.inputDataArray;
                Object.keys(customizationData).forEach(key => {
                    let cleanKey = key.replace("input", "");
                    let customizationText = document.getElementById(cleanKey);
                    customizationText.innerHTML = customizationData[key];
                });
                form.reset();
                let existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
            .catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
            });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");
            addLoadingClass(target);

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);

                let itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    let existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    let customizeModal = response.customizeModal;
                    let newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");

            // Alle Mengen-Inputs sammeln
            const quantityInputs = Array.from(document.querySelectorAll('input.js-quantity-value'));
            const wrappers = new Set();

            quantityInputs.forEach(qty => {
                const value = parseInt(qty.value);
                if (value > 0) {
                    const wrapper = qty.closest(".itemlistElement__wrapper");
                    if (wrapper) {
                        wrappers.add(wrapper);
                    }
                }
            });


            if (wrappers.size > 0) {
                const formDatas = new FormData();
                let index = 1;

                wrappers.forEach(wrapper => {
                    const itemIdInput = wrapper.querySelector('input.input_item_id');
                    const variantCodeInput = wrapper.querySelector('input.input_variant_code');
                    const qtyInput = wrapper.querySelector('input[type="number"]');

                    if (
                        itemIdInput &&
                        variantCodeInput &&
                        qtyInput &&
                        parseInt(qtyInput.value) > 0
                    ) {
                        formDatas.set(`input_item_id_${index}`, itemIdInput.value);
                        formDatas.set(`input_variant_code_${index}`, variantCodeInput.value);
                        formDatas.set(`input_item_quantity_${index}`, parseInt(qtyInput.value));
                        index++;
                    }
                });

                formDatas.set('item_count', index - 1); // Optional: Anzahl der Artikel


                // Ausgewählte Basket-Checkboxen
                const selectedCheckboxes = document.querySelectorAll('input[name="basketLists[]"]:checked');
                const selectedIds = Array.from(selectedCheckboxes).map(cb => cb.value);

                const hiddenBasketInput = document.querySelector('input[name="selected_basket_ids"]');
                if (hiddenBasketInput) {
                    hiddenBasketInput.value = JSON.stringify(selectedIds);
                }

                formDatas.set('selected_basket_ids', JSON.stringify(selectedIds));

                // Basket-Daten aus dem Select (für Backend)
                const basketOptions = document.querySelectorAll('#selectBasket option.js-selectCurrentBasket');
                const basketData = [];

                basketOptions.forEach(option => {
                    basketData.push({
                        basketId: option.getAttribute('data-basket-id'),
                        description: option.textContent.trim()
                    });
                });

                formDatas.set('basket_data', JSON.stringify(basketData));
                formDatas.set('action', 'shop_add_all_items_to_basket');

                addLoadingClass(target);

                // Debug-Ausgabe
                for (let pair of formDatas.entries()) {
                    console.log(pair[0], ':', pair[1]);
                }

                // AJAX senden
                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) throw "Could not save data";
                    const basketId = document.querySelector('.js-currentBasket')?.dataset.basketId || document.querySelector('#selectBasket')?.value;
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc, false);
                        setCurrentBasketAndReloadWithXhr(basketId);
                    }

                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }

                    wrappers.forEach(wrapper => {
                        const qtyInput = wrapper.querySelector('input[type="number"]');
                        if (qtyInput) qtyInput.value = 0;
                    });

                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);

                    const modal = document.getElementById("add_all_to_baskets");
                    if (modal) closeModal(modal);


                    return response.status;
                }).catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                    console.error(formDatas);
                });
            }

            e.preventDefault();
        }

        if (target.closest(".js-openMultiBasketModal")) {
            target = target.closest(".js-openMultiBasketModal");

            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper ? orderButtonWrapper.querySelector('.js-quantity-value') : null;

            if (quantityInput) {
                const quantity = parseInt(quantityInput.value, 10);
                if (isNaN(quantity) || quantity <= 0) {
                    e.preventDefault();
                    return;
                }
            }

            // Modal anzeigen
            showModal(document.getElementById("add_all_to_baskets"));


            // Basket-Auswahl dynamisch aufbauen
            const basketOptions = document.querySelectorAll('#selectBasket option.js-selectCurrentBasket');
            const basketListContainer = document.querySelector('.basket_list');
            basketListContainer.innerHTML = ''; // vorher leeren

            basketOptions.forEach(option => {
                const basketId = option.getAttribute('data-basket-id');
                const description = option.textContent.trim();

                const wrapper = document.createElement('div');
                wrapper.className = 'form-group checkbox-group';

                const label = document.createElement('label');
                label.className = 'specialcheckbox';

                const input = document.createElement('input');
                input.type = 'checkbox';
                input.name = 'basketLists[]';
                input.value = basketId;

                const descriptionText = document.createTextNode(description);
                const icon = document.createElement('i');

                label.appendChild(input);
                label.appendChild(descriptionText);
                label.appendChild(icon);
                wrapper.appendChild(label);
                basketListContainer.appendChild(wrapper);
            });

            e.preventDefault();
        }


    });
}

export function triggerUpdateBasketView() {
    let updateTimeout = false;
    let basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);
        eventListenerDiscountGroupSelect(basketView, updateTimeout);
        eventListenerPriceGroupSelect(basketView, updateTimeout);

        document.addEventListener('click', function(e) {
            if (basketUpdatePending && e.target.closest('.js-loadingAfterSubmit')) {
                e.preventDefault();
            }
        }, true);

        new CustomEvent('updateBasketViews', {
            detail: { message: 'Die Funktion wurde erfolgreich ausgeführt!' }
        });
    }
}



export function changeCurrentBasket() {
    const basketSelect = document.getElementById('selectBasket');

    if (basketSelect) {
        basketSelect.addEventListener('change', function () {
            const selectedBasketId = this.value;
            if (selectedBasketId) {
                let newTab = document.querySelector(`.js-changeCurrentBasket[data-basket-id="${selectedBasketId}"]`);
                if (newTab) {
                    newTab.click();
                    initContentTabs();
                    initBasketDiscountField();
                } else {
                    setCurrentBasketAndReloadWithXhr(selectedBasketId);
                }
            }
        });
    }
}

export function changeCurrentBasketByTabs() {
    for (let changeBasketTab of document.querySelectorAll('.js-changeCurrentBasket')) {
        changeBasketTab.addEventListener('click', function () {
            const selectedBasketId = this.dataset.basketId;
            if (selectedBasketId) {
                setCurrentBasketAndReloadWithXhr(selectedBasketId);
            }
        });
    }
}

export function initBasketDiscountField() {
    // Initialisiere für den aktiven Tab
    initActiveBasketDiscountField();

    // Event-Listener für Tab-Wechsel hinzufügen
    const tabButtons = document.querySelectorAll('.js-changeCurrentBasket');
    tabButtons.forEach(tab => {
        tab.addEventListener('click', initActiveBasketDiscountField);
    });
}

function initActiveBasketDiscountField() {
    // Die bestehende Logik, aber nur für den aktiven Tab
    const activeTab = document.querySelector('.js-changeCurrentBasket.is-active');
    if (!activeTab) return;

    const basketId = activeTab.dataset.basketId;
    const basketWrapper = document.querySelector(`.contentTabs__basketWrapper[data-basket-id="${basketId}"]`);
    if (!basketWrapper) return;

    const basketDiscountInput = basketWrapper.querySelector('#basket_discount');
    if (!basketDiscountInput) return;

    // Alte Event-Listener entfernen (gespeicherte Referenzen vom vorherigen Aufruf)
    if (basketDiscountInput._discountBlurHandler) {
        basketDiscountInput.removeEventListener("blur", basketDiscountInput._discountBlurHandler);
    }
    if (basketDiscountInput._discountKeyupHandler) {
        basketDiscountInput.removeEventListener("keyup", basketDiscountInput._discountKeyupHandler);
    }

    let updateTimeout = false;

    function handleBlur() {
        clearTimeout(updateTimeout);
        lockCheckoutButtons();
        updateTimeout = setTimeout(() => {
            const form = basketDiscountInput.closest("form");
            if (form) {
                const basketView = document.getElementById("userBasket");
                sendBasketForm(form, basketView);
            }
        }, 500);
    }

    function handleKeyup(e) {
        if (e.key === "Enter") {
            handleBlur();
        }
    }

    basketDiscountInput._discountBlurHandler = handleBlur;
    basketDiscountInput._discountKeyupHandler = handleKeyup;

    basketDiscountInput.addEventListener("blur", handleBlur);
    basketDiscountInput.addEventListener("keyup", handleKeyup);
}


export function initBasketFormSubmit() {
    function bindFormSubmit(activeWrapper) {
        const form = activeWrapper.querySelector('form#form_user_basket');
        if (!form) {
            console.warn('Kein Formular im aktiven Basket-Wrapper gefunden.');
            return;
        }

        // Doppelbindung verhindern
        if (form.dataset.listenerBound === "true") return;
        form.dataset.listenerBound = "true";

        form.addEventListener('submit', function () {
            // Extra-Felder aus dem aktiven Wrapper ins Formular klonen
            activeWrapper.querySelectorAll(
                '[name="basket_discount"], [name="input_price_group"], [name="input_discount_group"]'
            ).forEach(field => {
                const hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = field.name;
                hidden.value = field.value;
                form.appendChild(hidden);
            });

            // Basket-ID ins Formular hängen
            const basketId = activeWrapper.dataset.basketId;
            if (basketId) {
                const hiddenId = document.createElement('input');
                hiddenId.type = 'hidden';
                hiddenId.name = 'basket_id';
                hiddenId.value = basketId;
                form.appendChild(hiddenId);
            }
        });
    }

    // Initial aktiv
    const initialActive = document.querySelector('.contentTabs__basketWrapper.is-active');
    if (initialActive) {
        bindFormSubmit(initialActive);
    }

    // Bei Tab-Wechsel neu binden
    document.addEventListener('click', (e) => {
        const newActive = document.querySelector('.contentTabs__basketWrapper.is-active');
        if (newActive) {
            bindFormSubmit(newActive);
        }
    });
}


export function setupQuantityValidationDelegated(container = document) {
    container.addEventListener('blur', event => {
        const input = event.target;
        if (!input.matches('.js-quantity-value')) return;

        const min = input.min !== '' ? parseFloat(input.min) : -Infinity;
        const max = input.max === '0' ? Infinity : parseFloat(input.max) || Infinity;
        let val = parseFloat(input.value);

        if (isNaN(val)) {
            input.value = min !== -Infinity ? min : 0;
            return;
        }

        if (val > max) {
            input.value = max;
        } else if (val < min) {
            input.value = min;
        }
    }, true); // useCapture=true, damit Blur korrekt „nach oben“ bubbelt
}


export function initBasketDiscountClamp() {
    const inputs = document.querySelectorAll('.js-basket-discount');

    inputs.forEach(inputEl => {
        const min = parseFloat(inputEl.min);
        const max = parseFloat(inputEl.max);

        function clamp() {
            let value = parseFloat(inputEl.value);

            if (isNaN(value)) return;

            if (!isNaN(max) && value > max) value = max;
            if (!isNaN(min) && value < min) value = min;

            inputEl.value = value;
        }

        // Sofort begrenzen
        inputEl.addEventListener('input', clamp);

        // Sicherheitshalber beim Verlassen
        inputEl.addEventListener('blur', clamp);
    });
}


/**
 * Synchronisiert die noDiscount-Klasse zwischen
 * sizeVariant → colorVariant → mainItem
 *
 * Regeln:
 * 1) Wenn alle sizeVariants nach einem colorVariant noDiscount haben,
 *    erhält dieser colorVariant ebenfalls noDiscount.
 * 2) Wenn ALLE itemBasketBox-Elemente mit gleicher data-id (außer mainItem)
 *    noDiscount haben, erhält auch das mainItem noDiscount.
 *
 * Die Funktion ist defensiv implementiert und wirft keine Errors,
 * wenn DOM-Elemente fehlen oder unvollständig sind.
 */
export function syncNoDiscountState() {
    try {
        // Pro Warenkorb-Container separat auswerten, damit Artikel die in mehreren
        // Warenkörben (mit unterschiedlichen Berechtigungen) liegen sich nicht gegenseitig beeinflussen.
        const basketLists = document.querySelectorAll('.js-itemBasketList');
        const containers = basketLists && basketLists.length > 0
            ? Array.from(basketLists)
            : [document];

        containers.forEach(container => {
            const allBoxes = container.querySelectorAll('.itemBasketBox');
            if (!allBoxes || allBoxes.length === 0) return;

            // Gruppieren nach data-id unter Erhalt der DOM-Reihenfolge
            const groups = {};

            allBoxes.forEach(el => {
                if (!el || !el.dataset) return;

                const id = el.dataset.id;
                if (!id) return;

                if (!groups[id]) {
                    groups[id] = [];
                }
                groups[id].push(el);
            });

            Object.values(groups).forEach(group => {
                if (!Array.isArray(group) || group.length === 0) return;

                let lastColorVariant = null;
                let sizeBuffer = [];

                const evaluateColorVariant = () => {
                    if (!lastColorVariant || sizeBuffer.length === 0) {
                        sizeBuffer = [];
                        return;
                    }

                    const allNoDiscount = sizeBuffer.every(el =>
                        el && el.classList && el.classList.contains('noDiscount')
                    );

                    if (allNoDiscount && lastColorVariant.classList) {
                        lastColorVariant.classList.add('noDiscount');
                    }

                    sizeBuffer = [];
                };

                // ---------- STUFE 1 ----------
                group.forEach(el => {
                    if (!el || !el.classList) return;

                    if (el.classList.contains('colorVariant')) {
                        evaluateColorVariant();
                        lastColorVariant = el;
                    }

                    if (el.classList.contains('sizeVariant')) {
                        sizeBuffer.push(el);
                    }
                });

                evaluateColorVariant();

                // ---------- STUFE 2 ----------
                const mainItem = group.find(el =>
                    el && el.classList && el.classList.contains('mainItem')
                );

                if (!mainItem || !mainItem.classList) return;

                const variants = group.filter(el =>
                    el &&
                    el.classList &&
                    (el.classList.contains('colorVariant') || el.classList.contains('sizeVariant'))
                );

                if (variants.length === 0) return;

                const allHaveNoDiscount = variants.every(el =>
                    el.classList.contains('noDiscount')
                );

                if (allHaveNoDiscount) {
                    mainItem.classList.add('noDiscount');
                }
            });
        });
    } catch (err) {
        // Absichtlich stilles Failover:
        // Kein UI-Crash bei unerwarteten DOM-Zuständen
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('[syncNoDiscountState] aborted safely:', err);
        }
    }
}
